"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Context = require("../Context");
var actions = _interopRequireWildcard(require("../../actions"));
var _constants = require("../../constants");
var _appconfig = require("../../selectors/appconfig");
var _menu = require("../../selectors/menu");
var _Breadcrumbs = require("../Breadcrumbs");
var _SolutionSwitcher = _interopRequireDefault(require("./SolutionSwitcher.mds"));
var _ModuleIcon = _interopRequireDefault(require("./ModuleIcon"));
var _Nav = _interopRequireDefault(require("./Nav"));
var Styled = _interopRequireWildcard(require("./styles"));
var StyledMDS = _interopRequireWildcard(require("./styles/mds"));
var _menu2 = require("../../utils/menu");
var _sanitizer = require("../../utils/sanitizer");
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Header = ({
  headerActions,
  activeSolution = {},
  history,
  searchValueHandler,
  showBurgerMenu
}) => {
  const appconfig = (0, _Context.useSelector)(_appconfig.getAppconfig);
  const theme = (0, _styledComponents.useTheme)();
  const solutions = (0, _Context.useSelector)(_menu.getSolutions);
  const solutionsVisibleL1 = (0, _menu2.getVisibleMenuNodes)(solutions);
  const isMenuExpanded = (0, _Context.useSelector)(_menu.isExpanded);
  const dispatch = (0, _Context.useDispatch)();
  const toggleSidemenu = () => {
    dispatch(actions.toggleMenu(true));
  };
  const toggleMDSSidemenu = () => {
    dispatch(actions.toggleMenu(!isMenuExpanded));
  };
  const sanitizedDefaultRoute = (0, _react.useMemo)(() => (0, _sanitizer.sanitizeHref)((appconfig.defaultRoute ?? '').trim()), [appconfig.defaultRoute]);
  const clickOnLogoHandler = () => {
    if (sanitizedDefaultRoute) {
      const newPath = (0, _utils.stringStartsFromProtocol)(sanitizedDefaultRoute) ? sanitizedDefaultRoute : `${window.location.origin}${sanitizedDefaultRoute}`;
      window.location.href = newPath;
    }
  };
  const renderHeaderLeftControls = () => {
    if (theme.name === _constants.THEMES.mds) {
      return _react.default.createElement(StyledMDS.ControlsContainer, null, (appconfig.menu || showBurgerMenu) && _react.default.createElement(StyledMDS.TogglerContainer, null, _react.default.createElement(StyledMDS.MenuToggler, {
        onClick: toggleMDSSidemenu
      }, _react.default.createElement("span", null))), _react.default.createElement(StyledMDS.LogoContainer, {
        collapsedMenu: appconfig.headerBasedSitemap && !showBurgerMenu
      }, _react.default.createElement(StyledMDS.LogoInner, null, _react.default.createElement(StyledMDS.Logo, {
        onClick: clickOnLogoHandler,
        logo: appconfig.logo,
        isLink: Boolean(sanitizedDefaultRoute)
      }))), (appconfig.headerBasedSitemap || appconfig.menu) && _react.default.createElement(_SolutionSwitcher.default, {
        headerBasedSitemap: appconfig.headerBasedSitemap,
        header: appconfig.header,
        menu: appconfig.menu,
        showBurgerMenu: showBurgerMenu,
        solutions: solutionsVisibleL1,
        activeSolution: activeSolution,
        history: history
      }));
    }
    return appconfig.menu && _react.default.createElement(Styled.TogglerContainer, {
      collapsed: !isMenuExpanded
    }, _react.default.createElement(Styled.MenuToggler, {
      onClick: toggleSidemenu
    }, _react.default.createElement("span", null)));
  };
  return _react.default.createElement(Styled.HeaderContainer, null, _react.default.createElement(Styled.HeaderInner, null, renderHeaderLeftControls(), theme.name !== _constants.THEMES.mds && _react.default.createElement(Styled.BreadcrumbsArea, null, _react.default.createElement(_ModuleIcon.default, {
    icon: appconfig.icon
  }), _react.default.createElement(_Breadcrumbs.Breadcrumbs, {
    container: _Breadcrumbs.BreadcrumbsContainer,
    item: _Breadcrumbs.BreadcrumbLink,
    finalProps: {
      active: true
    },
    compare: (a, b) => a.weight - b.weight,
    removeProps: {
      weight: true
    }
  })), _react.default.createElement(_Nav.default, {
    headerActions: headerActions,
    searchValueHandler: searchValueHandler
  })));
};
var _default = exports.default = Header;